export default __webpack_public_path__ + "static/media/alunna.9e2c3af8.svg";